import { TableCell, TableRow, Theme, Typography } from "@mui/material";
import { ColorMap, TableBodyData } from "../../types";
import { formatCurrency } from "../../../../utils/utilityFunctions";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../../redux-store/reducers";


const colorMap: ColorMap = {
    profit: "success.500",
    loss: "error.500"
}
export default function StrategyDetailsTable({ data }: { data: TableBodyData }): JSX.Element {
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    return (
        <>
            {data.map((obj: any) => (
                <TableRow
                    key={obj.schemeName}
                    sx={(theme: Theme) => ({
                        '& td': {
                            paddingTop: "15px",
                            paddingBottom: "15px",
                            borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                        },
                        '& td:first-of-type': {
                            paddingLeft: "0px"
                        },
                    })}
                >
                    <TableCell align="left">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.primary,
                                '&:hover': {
                                    color: theme.palette.primary[500]
                                },
                            })}
                        >
                            {obj?.schemeName ?? "-"}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.primary,
                            })}
                        >
                            {obj?.investedValue < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.investedValue ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.investedValue ?? 0, locale, currencyCode })}`}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.primary
                            })}
                        >
                            {obj?.marketValue < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.marketValue ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.marketValue ?? 0, locale, currencyCode })}`}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.primary
                            })}
                        >
                            {!Number.isNaN(Number(obj?.exposure ?? 0)) ?
                                Math.round((obj?.exposure ?? 0) * 100) / 100 : '0'}%
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: obj?.percentage?.amount >= 0 ? colorMap["profit"] : colorMap["loss"],
                            })}
                        >

                            {obj?.realGainLossPercentage?.amount < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.realGainLossPercentage?.amount ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.realGainLossPercentage?.amount ?? 0, locale, currencyCode })}`}{`(${!Number.isNaN(Number(obj?.realGainLossPercentage?.percentage ?? 0)) ?
                                Math.round((obj?.realGainLossPercentage?.percentage ?? 0) * 100) / 100 : '0'}%)`}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.primary
                            })}
                        >
                            {obj?.inflow < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.inflow ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.inflow ?? 0, locale, currencyCode })}`}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.primary
                            })}
                        >
                            {obj?.outflow < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.outflow ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.outflow ?? 0, locale, currencyCode })}`}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: obj?.realGainLossPercentage?.amount >= 0 ? colorMap["profit"] : colorMap["loss"],
                            })}
                        >
                            {obj?.percentage?.amount < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.percentage?.amount ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.percentage?.amount ?? 0, locale, currencyCode })}`}{`(${!Number.isNaN(Number(obj?.percentage?.percentage ?? 0)) ?
                                Math.round((obj?.percentage?.percentage ?? 0) * 100) / 100 : '0'}%)`}
                        </Typography>
                    </TableCell>
                </TableRow>
            ))}
        </>

    )
}